import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import Footer from '../footer';
import {  useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useHistory } from "react-router";
import ImageUploader from "react-images-upload";

import { UserProvider, useUser } from '../../context/UserContext'

export default function Causas() {
  const history = useHistory();
  
  let { id } = useParams();
  let refForm;
  let emptyCausa = {
    title : null,
    img : null,
    dirigido : null,
    desc: null
  };

  const { usuario, cargandoUsuario, setCargandoUsuario, setData, login, setLogin } = useUser();

  const [causa, setCausa] = useState(emptyCausa);
  
  useEffect(() => {
    function fetchItems() {
      Axios.get(process.env.REACT_APP_API + '/api/v1/causa/' + id)
           .then( response => {
             setCausa(response.data);
           })
           .catch( e => {
             console.log(e);
           })
    }
    fetchItems();
  },[]);

  const handleSubmit = e => {
    e.preventDefault();
    Axios.post(process.env.REACT_APP_API + '/api/v1/causa', causa )
         .then( function( response ) {
           toast.success('Causa creada correctamente!', {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              onClose: () => {
                history.push({pathname:  "/causa/" + causa.id});
              } 
          });
          history.push({pathname:  "/causa/" + causa.id});
         })
         .catch( function(e){
           toast('Error');
           console.log(e)
         } );
  }

  const handleInputChange = (event) => {
      setCausa({
          ...causa,
          [event.target.name] : event.target.value
      })
  }

  const onDrop = picture => {
    let formData = new FormData();
    formData.append('file', picture.pop());
    const config = { headers: { 'content-type': 'multipart/form-data' } }
    Axios.post(process.env.REACT_APP_API + '/api/v1/image/upload', formData, config).then(
      response => {
        setCausa({
            ...causa,
            ["img"] : '/static/img/' + response.data.result.fileName
        })
      }
    );
    
  };
  
  return (
    <section id="causas-add">

      <form onSubmit={handleSubmit} ref={(ref) => refForm = ref} >
        <input type="hidden" name="id" value={causa.id}/>
        <div className="form-group">
          <label htmlFor="title">Titulo</label>
          <input id="title" className="form-control" type="text" value={causa.title ?? '' } onChange={handleInputChange} name="title" />
        </div>

        <div className="form-group">
          <label htmlFor="dirigido">Dirigido</label>
          <input id="dirigido" className="form-control" type="text" value={causa.dirigido ?? '' } onChange={handleInputChange} name="dirigido" />
        </div>

        <div className="form-group">
          <label htmlFor="desc">Descripcion</label>
          <textarea name="desc" id="desc" cols="10" rows="5" onChange={handleInputChange} value={causa.desc ?? '' }></textarea>
        </div>
        
        <div className="form-group">
          <label htmlFor="image">Imagen</label>
          <input id="image" className="form-control" type="text" value={causa.img ?? '' } onChange={handleInputChange} name="img" />
        </div>
        
        <ImageUploader
          withIcon={true}
          onChange={onDrop}
          imgExtension={[".jpg", ".gif", ".png", ".gif"]}
          maxFileSize={5242880}
        />

        <input type="submit"/>
      </form>

      <Footer />
      <ToastContainer />
    </section>
  )
}
